import { base64Encode } from './DataHelpers';

const getFacilityIdAndOriginToken = (facilityId: string | number | undefined, origin: string) => {
  return base64Encode(`${facilityId}&${origin}`);
};

export { getFacilityIdAndOriginToken };
